import { Input, Label } from '@startupquickstart/frontend';
import type { MinigameAuthoringPanelProps } from './types';

interface GuessWordConfig {
  word?: string;
  category?: string;
  maxGuesses?: number;
}

const DEFAULTS: Required<GuessWordConfig> = {
  word: '',
  category: '',
  maxGuesses: 6,
};

export function GuessWordPanel({
  value,
  onChange,
  disabled,
}: MinigameAuthoringPanelProps<GuessWordConfig>) {
  const v = { ...DEFAULTS, ...(value ?? {}) };
  const set = (patch: Partial<GuessWordConfig>) => onChange({ ...v, ...patch });

  return (
    <div className="space-y-4 rounded-lg border bg-muted/30 p-4">
      <div className="space-y-1">
        <h4 className="text-sm font-semibold">Guess the word</h4>
        <p className="text-xs text-muted-foreground">
          Hangman-style. Players guess letters; the word is revealed as they
          go.
        </p>
      </div>

      <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
        <div className="space-y-1 sm:col-span-2">
          <Label>Word</Label>
          <Input
            value={v.word}
            placeholder="ESPRESSO"
            disabled={disabled}
            onChange={(e) => set({ word: e.target.value })}
          />
        </div>
        <div className="space-y-1">
          <Label>Category</Label>
          <Input
            value={v.category}
            placeholder="Beverage"
            disabled={disabled}
            onChange={(e) => set({ category: e.target.value })}
          />
        </div>
        <div className="space-y-1">
          <Label>Max guesses</Label>
          <Input
            type="number"
            min={1}
            max={20}
            value={v.maxGuesses}
            disabled={disabled}
            onChange={(e) => set({ maxGuesses: Number(e.target.value) })}
          />
        </div>
      </div>
    </div>
  );
}
